/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import axios from 'axios';
import { Graphql } from '@common/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';
import { CREATE_WORK_PERMIT } from '@pages/ApplicationForm/api/graphql';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { workPermitConfig } from '../../../ApplicationForm/config/workPermit.config';
import { MarriageExemptiConfig } from '../../../ApplicationForm/config/marriageExemption.config';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IFormatAppMethods extends IPluginMethodMap {
  formatApp(args: any): any;
}

export interface CFormatAppProps {}

export class FormatAppService implements IAgentPlugin {
  readonly methods: IFormatAppMethods;
  static displayName = 'FormatAppService';

  constructor() {
    this.methods = {
      formatApp: this.formatApp.bind(this),
    };
  }

  public formatApp(args: any) {
    console.log('formatApp draftData : : :', args);

    const storageService = StorageModule.getInstance();
    storageService.set('DRAFT_APP_ID', args?.applicationNo, 'session');
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    const whoAmI =
      userData?.currentRole ??
      (userData?.userRoles && Array.isArray(userData?.userRoles)
        ? userData?.userRoles[0]?.name
        : null);
    const _variables = this._getVariables(args, whoAmI);

    console.log('formatApp draftData :: drafted', _variables);
    return _variables;
  }

  //asdnjn
  private _getVariables = (data: any, whoAmI: string) => {
    console.log('formatApp draftData data', data);
    try {
      const userdocuments = this.getDocuments(data?.documents, data);
      const orgdocuments = this.getDocuments(data?.documents, data, false);
      const marrexpdocs = this.getMarriageDocuments([
        ...(data?.documents || []),
        // ...(data?.marriageDocuments || []),
        // ...(data?.jamaicanDocuments || []),
      ]);
      const evidencedocuments =
        this.getEvidenceDocuments(
          data?.appealInfo &&
            Array.isArray(data?.appealInfo) &&
            data?.appealInfo.length > 0
            ? data?.appealInfo[data?.appealInfo?.length - 1]?.documents
            : []
        ) || [];
      const _staffComposition = this.getStaffComposition(
        data?.employerInfo?.saffCompsition
      );
      console.log('evidocs', evidencedocuments);
      console.log('po->', userdocuments, orgdocuments);
      console.log('formatApp draftData _staffComposition', _staffComposition);
      let status = data?.status;
      let type = data?.type;

      let renewalStatus = data?.renewalStatus;
      let lastModified = data?.updatedAt;
      let appliedOn = data?.appliedOn;
      let issuedon = data?.issuanceDate;
      const certificate = data?.pdf
        ? {
            name: `certificate-${data?.credentialNo}.pdf`,
            src: `data:application/pdf;base64,${data?.pdf}`,
          }
        : null;
      const verifyURL = data?.verifyURL;
      let certitrn = data?.issuedTo?.trn;
      let _marriageInitialData: any = {};
      _marriageInitialData = {
        ...marrexpdocs,
        legacy: data?.legacy ? 'Legacy' : null,
        badgeColor: 'black',
        badgeBg: 'orange',
        refusedvisadetail: this.getRefuseVisaDetail(data) ?? undefined,
        userEmail: data?.applicantInfo?.email ?? undefined,
        userTelephoneNumber: data?.applicantInfo?.primaryContactNo ?? undefined,
        expPhoneNumber: data?.applicantInfo?.primaryContactNo ?? undefined,
        type: data?.type,
        firstName: data?.applicantInfo?.firstName ?? undefined,
        lastName: data?.applicantInfo?.lastName ?? undefined,
        middleName: data?.applicantInfo?.middleName ?? undefined,
        expatriateTrn: data?.applicantInfo?.trn ?? undefined,
        maidenName: data?.applicantInfo?.maidenName ?? undefined,
        middleInitial: data?.applicantInfo?.middleName ?? undefined,
        nationality: data?.applicantInfo?.nationality,
        expOccupation: data?.applicantInfo?.occupation,
        address1: data?.applicantInfo?.address?.addressLine1 ?? null,
        address2: data?.applicantInfo?.address?.addressLine2 ?? null,
        city: data?.applicantInfo?.address?.city ?? null,
        country: data?.applicantInfo?.address?.country ?? null,
        parish: data?.applicantInfo?.address?.parish ?? null,
        postalCode: data?.applicantInfo?.address?.zipcode ?? null,
        userEmail2: data?.applicantInfo?.email ?? null,
        expEmail: data?.applicantInfo?.email ?? null,
        alias: data?.applicantInfo?.alias ?? null,
        previouslyMarried:
          data?.applicantInfo?.previouslyMarried === true ? 'yes' : 'no',
        refusedVisaJamaica:
          data?.applicantInfo?.refusedJamaicanVisa === true ? 'yes' : 'no',
        refusedVisa:
          data?.applicantInfo?.refusedVisaOrDenied === true ? 'yes' : 'no',
        criminalConvictions:
          data?.applicantInfo?.criminalActivity === true ? 'yes' : 'no',
        currentlyEmployed:
          data?.applicantInfo?.employed === true ? 'yes' : 'no',
        finCapable:
          data?.applicantInfo?.financiallyCapable === true ? 'yes' : 'no',
        isNameChange: data?.applicantInfo?.isNameChange === true ? 'yes' : 'no',
        _firstName: data?.applicantInfo?.firstName,
        _lastName: data?.applicantInfo?.lastName,
        _middleInitial: data?.applicantInfo?.middleName,
        _nationality: data?.applicantInfo?.nationality,
        _occupation: data?.applicantInfo?.occupation,
        isMailingAddressSame: data?.applicantInfo?.isMailingAddressSame
          ? 'yes'
          : 'no',
        isFirstNameChange: data?.applicantInfo?.isFirstNameChange
          ? 'yes'
          : 'no',
        isLastNameChange: data?.applicantInfo?.isLastNameChange ? 'yes' : 'no',
        isMiddleNameChange: data?.applicantInfo?.isMiddleNameChange
          ? 'yes'
          : 'no',
        isOccupationChange: data?.applicantInfo?.isOccupationChange
          ? 'yes'
          : 'no',
        isNationalityChange: data?.applicantInfo?.isNationalityChange
          ? 'yes'
          : 'no',
        isPassportExpired: data?.applicantInfo?.isPassportExpired
          ? 'yes'
          : 'no',
        isDependentExist: data?.applicantInfo?.isDependentExist ? 'yes' : 'no',

        noOfChildren: data?.applicantInfo?.childrenOrDependent
          ? data?.applicantInfo?.childrenOrDependent.toString()
          : '0',
        destinationCarribbeanState:
          data?.applicantInfo?.destinationCarribbeanState ?? undefined,
        natureOfProfessionalActivity:
          data?.applicantInfo?.natureOfProfessionalActivity ?? undefined,
        dateOfBirth: data?.applicantInfo?.dateOfBirth ?? null,
        gender: data?.applicantInfo?.gender ?? null,
        isLastNameExist:
          data?.applicantInfo?.isLastNameExist == true ? 'yes' : 'no',
        countryConvicted: data?.applicantInfo?.countryConvicted ?? null,
        dateOfConviction: data?.applicantInfo?.dateOfConviction ?? null,
        natureOfOffence: data?.applicantInfo?.natureOfOffence ?? null,
        divorcedOrWidowed: data?.applicantInfo?.divorceOrWidowed ?? null,
        refusedVisaDetails:
          data?.applicantInfo?.refusedVisaOrDeniedReason ?? null,
        refusedVisaJamaicaReason:
          data?.applicantInfo?.refusedJamaicanVisaReason ?? null,
        ifCriminalConviction:
          data?.applicantInfo?.criminalActivityReason ?? null,
        monthlySalary: data?.applicantInfo?.salary,
        criminalOffence:
          data?.applicantInfo?.criminalOffence === true
            ? 'yes'
            : data?.applicantInfo?.criminalOffence === false
            ? 'no'
            : null,
        employerAddress1:
          data?.applicantInfo?.lastEmployer?.address?.addressLine1 ?? null,
        employerAddress2:
          data?.applicantInfo?.lastEmployer?.address?.addressLine2 ?? null,
        employerCity: data?.applicantInfo?.lastEmployer?.address?.city ?? null,

        employerParish:
          data?.applicantInfo?.lastEmployer?.address?.parish ?? null,

        nameOfEmployer: data?.applicantInfo?.lastEmployer?.name ?? null,
        purposeOfRelocation:
          data?.applicantInfo?.purposeOfRelocation ?? undefined,

        telephoneOfEmployer:
          data?.applicantInfo?.lastEmployer?.primaryContactNo ?? null,
        trn: data?.applicantInfo?.trn ?? null,
        workPermitNumber:
          data?.applicantInfo?.lastEmployer?.credentialNo ?? null,
        workPermitExpiry: data?.applicantInfo?.lastEmployer?.wpExpiry ?? null,
        maritalStatus: data?.applicantInfo?.maritalStatus ?? null,
        passportExpiry: data?.applicantInfo?.passportExpiry ?? null,
        passportExpiryDate: data?.applicantInfo?.passportExpiry ?? null,
        passport: data?.applicantInfo?.passportNumber ?? null,
        expPassportNo: data?.applicantInfo?.passportNumber ?? undefined,
        typeOfPassport: data?.applicantInfo?.passportType ?? null,
        permitPeriodStart: data?.applicantInfo?.permissionPeriod?.from ?? null,
        permitPeriodEnd: data?.applicantInfo?.permissionPeriod?.to ?? null,
        placeOfBirth: data?.applicantInfo?.placeOfBirth ?? null,

        skills: data?.applicantInfo?.skills ?? null,
        employerAddress1Dep:
          data?.applicantInfo?.spouseLastEmployer?.address?.addressLine1 ??
          null,
        employerAddress2Dep:
          data?.applicantInfo?.spouseLastEmployer?.address?.addressLine2 ??
          null,
        employerCityDep:
          data?.applicantInfo?.spouseLastEmployer?.address?.city ?? null,
        employerParishDep:
          data?.applicantInfo?.spouseLastEmployer?.address?.parish ?? null,
        nameOfEmployerDep:
          data?.applicantInfo?.spouseLastEmployer?.name ?? null,
        workPermitNumberDep:
          data?.applicantInfo?.spouseLastEmployer?.credentialNo ?? null,
        workPermitExpiryDep:
          data?.applicantInfo?.spouseLastEmployer?.wpExpiry ?? null,
        telephoneOfHusbandWife:
          data?.applicantInfo?.spouseLastEmployer?.telephoneOfHusbandWife ??
          null,
        husbandOrWifeName: data?.applicantInfo?.spouseName ?? null,
        husbandOrWifeNationality:
          data?.applicantInfo?.spouseNationality ?? null,
        // workExperience: this.getWorkExperience(data?.applicantInfo),
        userNatureOfBusiness:
          data?.applicantInfo?.natureOfBusiness ?? undefined,
        countryOfBirth: data?.applicantInfo?.countryOfBirth ?? undefined,

        workedInJamaica:
          data?.applicantInfo?.workedInJamaica === true
            ? 'yes'
            : data?.applicantInfo?.workedInJamaica === false
            ? 'no'
            : null,

        // ******************************************************88
        // ******************************************************88
        // ******************************************************88
        // ******************************************************88
        // ******************************************************88
        jamaicanLastName: data?.jamaicanInfo?.lastName ?? null,
        jamaicanFirstName: data?.jamaicanInfo?.firstName ?? null,
        jamaicanMiddleName: data?.jamaicanInfo?.middleName ?? null,
        jamaicanMaidenName: data?.jamaicanInfo?.maidenName ?? null,
        jamaicanPlaceOfBirth: data?.jamaicanInfo?.placeOfBirth ?? null,
        jamaicanNationality: data?.jamaicanInfo?.nationality ?? null,
        typeOfIndentification: data?.jamaicanInfo?.typeOfIdentification ?? null,
        jamaicanDateOfBirth: data?.jamaicanInfo?.dateOfBirth ?? null,
        jamaicanTrn: data?.jamaicanInfo?.trn ?? null,
        jamaicanSex: data?.jamaicanInfo?.gender ?? null,
        jamaicanNIS: data?.jamaicanInfo?.NIS ?? null,
        jamaicanEmployedState:
          data?.jamaicanInfo?.jamaicanEmployedState ?? null,
        jamaicanPreviouslyMarried:
          data?.jamaicanInfo?.previouslyMarried === true ? 'yes' : 'no',
        jamaicanDivorcedOrWidowed: data?.jamaicanInfo?.divorceOrWidowed ?? null,
        addressOfEmployer:
          data?.jamaicanInfo?.addressOfEmployer?.addressLine1 ?? null,
        jamaincaSpouseLiving: data?.jamaicanInfo?.jamaincaSpouseLiving ?? null,
        // birthNaturalizationCertificateNo : data?.jamaicanInfo?.birthNaturalizationCertificateNo ?? null,
        citizenshipProof: data?.jamaicanInfo?.citizenshipProof ?? null,
        birthCertificateNo: data?.jamaicanInfo?.birthCertificateNo ?? null,
        naturalizationCertificateNo:
          data?.jamaicanInfo?.NaturalizationCertificateNo ?? null,
        jamaicanCurrentlyEmployed:
          data?.jamaicanInfo?.employed === true ? 'yes' : 'no',
        jamaicanMonthlySalary: data?.jamaicanInfo?.salary ?? null,
        jamaicanOtherIncome: data?.jamaicanInfo?.otherIncomeSource ?? null,
        jamaicanEmailAddress: data?.jamaicanInfo?.email ?? null,
        jamaicanContactNumber: data?.jamaicanInfo?.primaryContactNo ?? null,
        jamaicanFinCapable:
          data?.jamaicanInfo?.financiallyCapable === true ? 'yes' : 'no',
        jamaicanOccupation: data?.jamaicanInfo?.occupation ?? null,
        jamaicanaddress1: data?.jamaicanInfo?.address?.addressLine1 ?? null,
        jamaicancity: data?.jamaicanInfo?.address?.city ?? null,
        jamaicanparish: data?.jamaicanInfo?.address?.parish ?? null,

        // ************************************************************
        // ************************************************************
        // ************************************************************
        // ************************************************************
        // ************************************************************

        marriageOfficerName: data?.marriageInfo?.nameOfOfficer ?? null,
        groomsName: data?.marriageInfo?.groomName ?? null,
        bridesName: data?.marriageInfo?.brideName ?? null,
        placeOfMarriage: data?.marriageInfo?.placeOfMarriage ?? null,
        marriageCertificateNo:
          data?.marriageInfo?.marriageCertificateNo ?? null,
        dateOfMarriage: data?.marriageInfo?.dateOfMarriage ?? null,
        addressOfCouple:
          data?.marriageInfo?.addressOfCouple?.addressLine1 ?? null,
        coupleParish: data?.marriageInfo?.addressOfCouple?.parish ?? null,
        coupleCity: data?.marriageInfo?.addressOfCouple?.city ?? null,
      };
      // * _initialData = Personal Details
      let _initialData: any = {};
      // * __initialData = Org Details
      let issuedData: any = {};
      let __initialData: any = {};
      if (data?.issued) {
        issuedData = {
          legacy: data?.legacy ? 'Legacy' : null,
          badgeColor: 'black',
          badgeBg: 'orange',
          lastName:
            data?.applicantInfo?.lastName ??
            data?.application?.applicantInfo?.lastName ??
            null,
          middleInitial: data?.applicantInfo?.middleName ?? null,
          alias: data?.applicantInfo?.alias ?? null,
          firstName:
            data?.applicantInfo?.firstName ??
            data?.application?.applicantInfo?.firstName ??
            null,
          nationality: data?.applicantInfo?.nationality ?? null,
          passport: data?.applicantInfo?.passportNumber ?? null,
          gender: data?.applicantInfo?.gender ?? null,
          trn: data?.applicantInfo?.trn ?? null,
          businessName: data?.employerInfo?.name ?? null,
          userEmail:
            data?.applicantInfo?.email ??
            data?.application?.applicantInfo?.email ??
            undefined,
          userTelephoneNumber:
            data?.applicantInfo?.primaryContactNo ?? undefined,
        };
      } else {
        _initialData = {
          ...userdocuments,
          qualification: this.getQualification(
            data?.applicantInfo?.qualification
          ),
          ...this.getEducationInfo(data?.applicantInfo?.qualification, data),
          ...this.getEmploymentInfo(
            data?.applicantInfo?.employmentStatus,
            data
          ),

          ...this.getDependentInfo(data),
          evidencedocuments: evidencedocuments,
          legacy: data?.legacy ? 'Legacy' : null,
          badgeColor: 'black',
          badgeBg: 'orange',
          type: data?.type,
          // workPermit: data?.employerInfo?.credentialNo ?? null,
          // isMailingAddressSame: 'yes',
          // acknowledgementCheck: 'no',
          maidenName: data?.applicantInfo?.maidenName ?? undefined,
          selfAddress1:
            data?.applicantInfo?.employmentStatus === 'SELF_EMPLOYED'
              ? data?.applicantInfo?.employmentAddress?.addressLine1
              : undefined,
          otherNationality: data?.applicantInfo?.otherNationality ?? undefined,
          passportIssuanceDate:
            data?.applicantInfo?.passportIssuanceDate ?? undefined,
          selfAddress2:
            data?.applicantInfo?.employmentStatus === 'SELF_EMPLOYED'
              ? data?.applicantInfo?.employmentAddress?.addressLine2
              : undefined,
          selfCity:
            data?.applicantInfo?.employmentStatus === 'SELF_EMPLOYED'
              ? data?.applicantInfo?.employmentAddress?.city
              : undefined,
          selfParish:
            data?.applicantInfo?.employmentStatus === 'SELF_EMPLOYED'
              ? data?.applicantInfo?.employmentAddress?.parish
              : undefined,
          selfCountry:
            data?.applicantInfo?.employmentStatus === 'SELF_EMPLOYED'
              ? data?.applicantInfo?.employmentAddress?.country
              : undefined,
          selfOccupation:
            data?.applicantInfo?.employmentStatus === 'SELF_EMPLOYED'
              ? data?.applicantInfo?.occupation
              : undefined,
          employedAddress1:
            data?.applicantInfo?.employmentStatus === 'EMPLOYED'
              ? data?.applicantInfo?.employmentAddress?.addressLine1
              : undefined,
          employedAddress2:
            data?.applicantInfo?.employmentStatus === 'EMPLOYED'
              ? data?.applicantInfo?.employmentAddress?.addressLine2
              : undefined,
          employedCity:
            data?.applicantInfo?.employmentStatus === 'EMPLOYED'
              ? data?.applicantInfo?.employmentAddress?.city
              : undefined,
          employedParish:
            data?.applicantInfo?.employmentStatus === 'EMPLOYED'
              ? data?.applicantInfo?.employmentAddress?.parish
              : undefined,
          employedCountry:
            data?.applicantInfo?.employmentStatus === 'EMPLOYED'
              ? data?.applicantInfo?.employmentAddress?.country
              : undefined,
          employmentStatus: data?.applicantInfo?.employmentStatus,

          address1: data?.applicantInfo?.address?.addressLine1 ?? null,
          address2: data?.applicantInfo?.address?.addressLine2 ?? null,
          intendedStreetAddress1:
            data?.applicantInfo?.intendedAddress?.addressLine1 ?? null,
          intendedStreetAddress2:
            data?.applicantInfo?.intendedAddress?.addressLine2 ?? null,
          streetAddress1: data?.applicantInfo?.address?.addressLine1 ?? null,
          streetAddress2: data?.applicantInfo?.address?.addressLine2 ?? null,
          noOfYearsWithCompany:
            parseInt(data?.applicantInfo?.noOfYearsWithCompany) ?? null,
          city: data?.applicantInfo?.address?.city ?? null,
          country: data?.applicantInfo?.address?.country ?? null,
          parish: data?.applicantInfo?.address?.parish ?? null,
          postalCode: data?.applicantInfo?.address?.zipcode ?? null,
          userEmail:
            data?.applicantInfo?.email ??
            data?.application?.applicantInfo?.email ??
            null,
          UserEmail:
            data?.applicantInfo?.email ??
            data?.application?.applicantInfo?.email ??
            null,
          alias: data?.applicantInfo?.alias ?? null,
          noOfChildren: data?.applicantInfo?.childrenOrDependent
            ? parseInt(data?.applicantInfo?.childrenOrDependent)
            : undefined,
          destinationCarribbeanState:
            data?.applicantInfo?.destinationCarribbeanState ?? undefined,
          natureOfProfessionalActivity:
            data?.applicantInfo?.natureOfProfessionalActivity ?? undefined,
          dateOfBirth: data?.applicantInfo?.dateOfBirth ?? null,
          firstName:
            data?.applicantInfo?.firstName ??
            data?.application?.applicantInfo?.firstName ??
            null,
          gender: data?.applicantInfo?.gender ?? null,
          countryConvicted: data?.applicantInfo?.countryConvicted ?? null,
          dateOfConviction: data?.applicantInfo?.dateOfConviction ?? null,
          natureOfOffence: data?.applicantInfo?.natureOfOffence ?? null,
          criminalOffence:
            data?.applicantInfo?.criminalOffence === true ? 'yes' : 'no',
          employerAddress1:
            data?.applicantInfo?.lastEmployer?.address?.addressLine1 ?? null,
          employerAddress2:
            data?.applicantInfo?.lastEmployer?.address?.addressLine2 ?? null,
          employerCity:
            data?.applicantInfo?.lastEmployer?.address?.city ?? null,

          employerParish:
            data?.applicantInfo?.lastEmployer?.address?.parish ?? null,

          nameOfEmployer: data?.applicantInfo?.lastEmployer?.name ?? null,
          purposeOfRelocation:
            data?.applicantInfo?.purposeOfRelocation ?? undefined,

          telephoneOfEmployer:
            data?.applicantInfo?.lastEmployer?.primaryContactNo ?? null,
          trn: data?.applicantInfo?.trn ?? null,
          workPermitNumber:
            data?.applicantInfo?.lastEmployer?.credentialNo ?? null,
          // workPermitNumber:data?.applicationNo ?? null,
          workPermitExpiry: data?.applicantInfo?.lastEmployer?.wpExpiry ?? null,
          workPermitExpiryDep:
            data?.applicantInfo?.spouseLastEmployer?.wpExpiry ?? null,
          lastName:
            data?.applicantInfo?.lastName ??
            data?.application?.applicantInfo?.lastName ??
            null,
          maritalStatus: data?.applicantInfo?.maritalStatus ?? null,
          middleInitial: data?.applicantInfo?.middleName ?? null,
          nationality: data?.applicantInfo?.nationality ?? null,

          occupation: data?.applicantInfo?.occupation ?? null,

          passportExpiry: data?.applicantInfo?.passportExpiry ?? null,
          passport: data?.applicantInfo?.passportNumber ?? null,
          typeOfPassport: data?.applicantInfo?.passportType ?? null,
          permitPeriodStart:
            data?.applicantInfo?.permissionPeriod?.from ?? null,
          permitPeriodEnd: data?.applicantInfo?.permissionPeriod?.to ?? null,
          placeOfBirth: data?.applicantInfo?.placeOfBirth ?? null,
          martialStatus: data?.applicantInfo?.maritalStatus ?? null,
          image: data?.applicantInfo?.image ?? null,
          skills: data?.applicantInfo?.skills ?? null,
          employerAddress1Dep:
            data?.applicantInfo?.spouseLastEmployer?.address?.addressLine1 ??
            null,
          employerAddress2Dep:
            data?.applicantInfo?.spouseLastEmployer?.address?.addressLine2 ??
            null,
          employerCityDep:
            data?.applicantInfo?.spouseLastEmployer?.address?.city ?? null,
          employerParishDep:
            data?.applicantInfo?.spouseLastEmployer?.address?.parish ?? null,
          nameOfEmployerDep:
            data?.applicantInfo?.spouseLastEmployer?.name ?? null,
          workPermitNumberDep:
            data?.applicantInfo?.spouseLastEmployer?.credentialNo ?? null,
          husbandOrWifeName: data?.applicantInfo?.spouseName ?? null,
          husbandOrWifeNationality:
            data?.applicantInfo?.spouseNationality ?? null,
          telephoneOfHusbandWife:
            data?.applicantInfo?.spouseLastEmployer?.telephoneOfHusbandWife ??
            null,
          workExperience: this.getWorkExperience(data?.applicantInfo),
          userNatureOfBusiness:
            data?.applicantInfo?.natureOfBusiness ?? undefined,
          businessTrn: data?.employerInfo?.trn ?? null,
          countryOfBirth: data?.applicantInfo?.countryOfBirth ?? undefined,

          workedInJamaica:
            data?.applicantInfo?.workedInJamaica === true ? 'yes' : 'no',
          comment: data?.comment ?? null,
          userTelephoneNumber:
            data?.applicantInfo?.primaryContactNo ?? undefined,
        };
        __initialData = {
          ...orgdocuments,
          ..._staffComposition,
          // ...this.getEmploymentInfo(
          //   data?.applicantInfo?.employmentStatus,
          //   data
          // ),
          // ...this.getEducationInfo(data?.applicantInfo?.qualification, data),

          evidencedocuments: evidencedocuments,
          // isMailingAddressSame: 'yes',
          // acknowledgementCheck: 'no',
          type: data?.type,
          legacy: data?.legacy ? 'Legacy' : null,
          badgeColor: 'black',
          badgeBg: 'orange',
          businessAddress1: data?.employerInfo?.address?.addressLine1 ?? null,
          businessAddress2: data?.employerInfo?.address?.addressLine2 ?? null,
          businessCity: data?.employerInfo?.address?.city ?? null,
          businessCountry: data?.employerInfo?.address?.country ?? null,
          businessParish: data?.employerInfo?.address?.parish ?? null,
          businessPostalCode: data?.employerInfo?.address?.zipcode ?? null,
          dateOfReg: data?.employerInfo?.dateOfRegistration ?? null,
          email: data?.employerInfo?.email ?? null,
          faxNumber: data?.employerInfo?.fax ?? null,
          businessName: data?.employerInfo?.name ?? null,
          natureOfBusiness: data?.employerInfo?.natureOfBusiness?.includes(':')
            ? data?.employerInfo?.natureOfBusiness?.split(':')?.[1]
            : data?.employerInfo?.natureOfBusiness ?? undefined,
          mailingAddress1:
            data?.employerInfo?.operatingAddress?.addressLine1 ?? null,
          mailingAddress2:
            data?.employerInfo?.operatingAddress?.addressLine2 ?? null,
          mailingCity: data?.employerInfo?.operatingAddress?.city ?? null,
          mailingCountry: data?.employerInfo?.operatingAddress?.country ?? null,
          mailingParish: data?.employerInfo?.operatingAddress?.parish ?? null,
          mailingPostalCode:
            data?.employerInfo?.operatingAddress?.zipcode ?? null,
          telephoneNumber: data?.employerInfo?.primaryContactNo ?? null,
          // totalStaff: data?.employerInfo?.totalStaff
          //   ? parseInt(data?.employerInfo?.totalStaff)
          //   : 0,
          tccExpiryDate: data?.employerInfo?.tccExpiryDate ?? null,
          tccNumber: data?.employerInfo?.tccNumber ?? null,
          businessTrn: data?.employerInfo?.trn ?? null,
          website: data?.employerInfo?.website ?? null,
          workPermit: data?.employerInfo?.credentialNo ?? null,
          jobTitle: data?.jobInfo?.JobTitle ?? null,
          qualifications: data?.jobInfo?.necessaryQualification ?? null,
          car: data?.jobInfo?.allowances?.car,
          entertainment: data?.jobInfo?.allowances?.entertainment,
          house: data?.jobInfo?.allowances?.house,
          allowanceOther: data?.jobInfo?.allowances?.other,
          salary: data?.jobInfo?.salaryOffered,
          byAdvertisement:
            data?.jobInfo?.stepsForJaimacan?.byAdvertisement?.value ?? null,

          jobId: data?.jobInfo?.JobId ?? null,
          jobDuties: data?.jobInfo?.jobDuties ?? null,
          salaryOffered: data?.jobInfo?.salaryOffered,
          registeredLMIS:
            data?.jobInfo?.registeredLMIS === true
              ? 'yes'
              : data?.jobInfo?.registeredLMIS === false
              ? 'no'
              : null,
          workingHours: data?.jobInfo?.workingHours ?? null,
          benefitsReceived:
            data?.jobInfo?.benefitsReceived === true
              ? 'yes'
              : data?.jobInfo?.benefitsReceived === false
              ? 'no'
              : null,
          didJamaicanApply:
            data?.jobInfo?.stepsForJaimacan?.didJamaicanApply === true
              ? 'yes'
              : data?.jobInfo?.stepsForJaimacan?.didJamaicanApply === false
              ? 'no'
              : null,
          appliedCandidates:
            data?.jobInfo?.stepsForJaimacan?.appliedCandidates ?? 0,
          reasonNoneHired:
            data?.jobInfo?.stepsForJaimacan?.reasonNoneHired ?? null,
          noStepTaken: data?.jobInfo?.stepsForJaimacan?.noStepTaken ?? null,
          comment: data?.comment ?? null,
        };
      }
      console.log('formatApp draftData _initialData', _initialData);
      return {
        certificate,
        verifyURL,
        issuedData,
        renewalStatus,
        _initialData,
        __initialData,
        _marriageInitialData,
        type,
        lastModified,
        appliedOn,
        issuedon,
        certitrn,
        ...data,
        status:
          data?.renewalStatus === 'APPLIED_FOR_RENEWAL'
            ? data?.renewalStatus
            : data?.status,
      };
    } catch (err) {
      console.log('formatApp draftData error', err);
    }
  };

  private getStaffComposition(data: any) {
    let _staffComposition: any = {};
    console.log('formatApp getStaffComposition bla', data);
    try {
      data &&
        Array.isArray(data) &&
        data.length > 0 &&
        data.map((ele) => {
          console.log('formatApp ele bla', ele);
          if (ele?.citizenship === 'JAMAICAN') {
            _staffComposition = {
              ..._staffComposition,
              jamaicanProfessional: ele?.professional,
              jamaicanClerks: ele?.clerksOrServiceWorker,
              jamaicanSkilledWorkers: ele?.skilledWorkers,
              jamaicanPlant: ele?.plantAndMachineOperators,
              jamaicanElementary: ele?.elementaryOccupations,
            };
          } else if (ele?.citizenship === 'CARRICOM') {
            _staffComposition = {
              ..._staffComposition,
              carricomProfessional: ele?.professional,
              carricomClerks: ele?.clerksOrServiceWorker,
              carricomSkilledWorkers: ele?.skilledWorkers,
              carricomPlant: ele?.plantAndMachineOperators,
              carricomElementary: ele?.elementaryOccupations,
            };
          } else if (ele?.citizenship === 'COMMON_WEALTH') {
            _staffComposition = {
              ..._staffComposition,
              commonWealthProfessional: ele?.professional,
              commonWealthClerks: ele?.clerksOrServiceWorker,
              commonWealthSkilledWorkers: ele?.skilledWorkers,
              commonWealthPlant: ele?.plantAndMachineOperators,
              commonWealthElementary: ele?.elementaryOccupations,
            };
          } else if (ele?.citizenship === 'FOREGION') {
            _staffComposition = {
              ..._staffComposition,
              foreignProfessional: ele?.professional,
              foreignClerks: ele?.clerksOrServiceWorker,
              foreignSkilledWorkers: ele?.skilledWorkers,
              foreignPlant: ele?.plantAndMachineOperators,
              foreignElementary: ele?.elementaryOccupations,
            };
          }
        });
      console.log('formatApp _staffComposition bla : :', _staffComposition);
      return _staffComposition;
    } catch (err) {}
  }
  private getEvidenceDocuments(data: any) {
    let _similarDoc: any[] = [];
    console.log('evDoc', _similarDoc);
    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((doc: any) => {
        _similarDoc.push({
          name: doc?.name,
          src: doc?.src,
          type: doc?.fileType,
          docType: doc?.type,
        });
      });

    return _similarDoc;
  }
  private getDocuments(data: any, formData: any, isUser = true) {
    let _documents: any = {};
    let docData: any =
      workPermitConfig?.[isUser ? 'userDocuments' : 'employerDocuments'];
    const csmeDocData = [
      { id: 'occupation', payload: 'Graduates', newItem: 'graduateQual' },
      { id: 'occupation', payload: 'Artiste', newItem: 'nolGender' },
      { id: 'occupation', payload: 'Musicians', newItem: 'nolMusic' },
      { id: 'occupation', payload: 'Sport_Persons', newItem: 'nolSports' },
      { id: 'occupation', payload: 'Media_Workers', newItem: 'nolMedia' },
      { id: 'occupation', payload: 'Nurses', newItem: 'nurseQual' },
      { id: 'occupation', payload: 'Teachers', newItem: 'teacherQual' },
      {
        id: 'occupation',
        payload: 'Holders_of_Associate_Degree',
        newItem: 'associateDegreeQual',
      },
      { id: 'occupation', payload: 'Nurses', newItem: 'nurseQual' },
    ];

    csmeDocData?.forEach((ele) => {
      console.log(
        'hg->',
        ele?.id,
        formData?.applicantInfo?.[ele?.id],
        ele?.payload
      );
      if (formData?.applicantInfo?.[ele?.id] !== ele?.payload) {
        docData[ele?.newItem] = undefined;
      }
    });

    try {
      docData &&
        Object.entries(docData)
          .filter((item) => item)
          .forEach((ele, index) => {
            let _similarDoc: any[] = [];
            const tempAns = data?.filter((item: any) => item?.type === ele[1]);
            console.log(tempAns, 'miu->');
            const doc = tempAns?.[0];
            if (doc) {
              console.log('formatApp getDocuments ', doc?.type, ele);
              _similarDoc.push({
                name: doc?.name,
                src: doc?.src,
                type: doc?.fileType,
              });
              _documents[ele[0]] = _similarDoc;
            }
          });
      console.log('formatApp getDocuments ', _documents);
    } catch (err) {
      console.log('formatApp getDocuments error', err);
    }
    return _documents;
  }
  private getMarriageDocuments(data: any, isUser = true) {
    let _documents: any = {};
    try {
      MarriageExemptiConfig?.['availableDocuments'] &&
        Object.entries(MarriageExemptiConfig?.['availableDocuments']).forEach(
          (ele, index) => {
            let _similarDoc: any[] = [];
            const tempAns = data?.filter((item: any) => item?.type === ele[1]);
            console.log(tempAns, 'miu->');
            const doc = tempAns?.[0];
            if (doc) {
              console.log('formatApp getDocuments ', doc?.type, ele);
              _similarDoc.push({
                name: doc?.name,
                src: doc?.src,
                type: doc?.fileType,
              });
              _documents[ele[0]] = _similarDoc;
            }
          }
        );
      console.log('formatApp getDocuments ', _documents);
    } catch (err) {
      console.log('formatApp getDocuments error', err);
    }
    return _documents;
  }
  private getQualification(data: any) {
    let _qualification: any[] = [];
    console.log(`workPermitApp service getQualification`, data);
    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.forEach((ele: any) => {
        _qualification.push({
          qualificationName: ele?.degree,
          dateOfQualification: ele?.from,
        });
      });
    return _qualification;
  }

  private getRefuseVisaDetail(data: any) {
    let refuseVisa: any[] = [];
    data &&
      Array.isArray(data?.applicantInfo?.refusionDetail) &&
      data?.applicantInfo?.refusionDetail?.length > 0 &&
      data?.applicantInfo?.refusionDetail.forEach((ele: any) => {
        refuseVisa.push({
          id: `${ele?.country}${ele?.reason}`,
          refusedVisaCountry: ele?.country,
          refusedVisaReason: ele?.reason,
        });
      });
    return refuseVisa;
  }
  private getEmploymentInfo(empStatus: any, fullData: any) {
    console.log('stu->', fullData?.studentEducationDetail);
    if (empStatus === 'STUDENT') {
      const student = fullData?.studentEducationDetail;
      console.log('stu->', student);
      return {
        employmentStatus: empStatus,
        educationType:
          student?.educationType === 'Academic degree programme' ||
          student?.educationType === 'Vocational training'
            ? student?.educationType
            : student?.educationType
            ? 'others'
            : undefined,
        educationTypeOthers:
          student?.educationType !== 'Academic degree programme' &&
          student?.educationType !== 'Vocational training'
            ? student?.educationType
            : undefined,

        degree: student?.degreeOrCertificate,
        studentTelephone: student?.primaryContactNo,
        studentEmailAddress: student?.email,
        institutionName: student?.instituteName,
        institutionAddress: student?.instituteAddress?.addressLine1,
      };
    }
    return {};
  }

  private getEducationInfo(data: any, fullData: any) {
    console.log('qual->', data, fullData);
    if (Array.isArray(data) && data?.length > 0) {
      const qualifications = data?.map((qualification: any) => {
        console.log('qual->', qualification);
        return {
          dateOfQualification: qualification?.dateReceived,
          qualificationName: `${qualification?.degree}`,

          name: qualification?.institute,
          address1: qualification?.address?.addressLine1,
          address2: qualification?.address?.addressLine2,
          city: qualification?.address?.city,
          parish: qualification?.address?.parish,
          country: qualification?.address?.country,
        };
      });
      let qualType =
        fullData?.type === 'NEW_WORK_PERMIT' ||
        fullData?.type === 'RENEW_WORK_PERMIT'
          ? {}
          : { qualification: qualifications };
      console.log('qual->', qualType);
      return {
        ...qualType,
      };
    }
    return {};
  }

  private getDependentInfo(data: any) {
    let _dependentInfo: any[] = [];
    console.log(
      `workPermitApp service getDependentInfo`,
      data?.dependentInfo,
      data
    );
    data &&
      Array.isArray(data?.dependentInfo) &&
      data?.dependentInfo.length > 0 &&
      data?.dependentInfo.forEach((ele: any) => {
        _dependentInfo.push({
          ...this.getDocuments(ele?.documents, data),
          dependentType: ele?.dependentType,
          dependentName: ele?.name,
          dependentRelationship: ele?.relationship,
          dependentPassport: ele?.passportNumber,
          dependentSex: ele?.gender,
          dependentNationality: ele?.nationality,
          dependentAge: `${ele?.age}`,
        });
      });
    return {
      dependentInfo: _dependentInfo,
      dependents: _dependentInfo.length > 0 ? 'yes' : undefined,
    };
  }

  private getWorkExperience(data: any) {
    let _workExperience: any[] = [];
    console.log(
      `workPermitApp service getWorkExperience`,
      data?.workExperience
    );
    data &&
      Array.isArray(data?.workExperience) &&
      data?.workExperience.length > 0 &&
      data?.workExperience.forEach((ele: any) => {
        _workExperience.push({
          wePeriodStart: ele?.from,
          wePeriodEnd: ele?.to,
          jobDutyType: ele?.jobDuty,
          organizationName: ele?.nameOfOrganization,
        });
      });
    return _workExperience;
  }
}
